<template>
    <div class="IndexBox">
        <CommonHeader :info="traceabilityInfo" />
        <template v-if="emptyFlag">
            <div class="indexEmpty">
                <CommonEmpty :description="calcEmptyDesc" :imageSize="'200'" :errorType="'loadingError'" />
            </div>
        </template>
        <template v-else>
            <CommonTop :cropName="traceabilityInfo.name" />
            <div class="IndexContent">
                <van-tabs v-model="tabsActive" color="#2a82e4" title-active-color="#2a82e4"
                    title-inactive-color="#808080" animated>
                    <van-tab v-for="item in tabsList" :name="item.value" :key="item.value" :title="item.label">
                        <component :name="item.value" :info="traceabilityInfo" ref="componentRef" :is="calcTabsPage"
                            @showSheet="showSheet">
                        </component>
                    </van-tab>
                </van-tabs>
            </div>
            <van-action-sheet v-model="sheetFlag" :actions="mapOptions" :cancel-text="$t('common.cancel')"
                close-on-click-action @select="sheetChange" />
        </template>
    </div>
</template>
<script>
import CommonHeader from '../components/common/commonHeader.vue';
import CommonTop from '../components/common/commonTop.vue';
import { mapPointTxTurnBaiDu, Decrypt } from '../utils/index';
import ParkInfo from '../components/page/parkInfo.vue'; // 园区信息
import CropInfo from '../components/page/cropInfo.vue'; // 作物信息
import VideoInfo from '../components/page/videoInfo.vue'; // 视频信息
import EnvironmentalInfo from '../components/page/environmentalInfo.vue'; // 环境信息
import AgriculturalInfo from '../components/page/agriculturalInfo.vue'; // 农事信息
import ReportInfo from '../components/page/reportInfo.vue'; // 报告信息
import PickingInfo from '../components/page/pickingInfo.vue'; // 采摘信息
import { CODE_SUCCESS } from '../utils/constant'; // 接口请求成功的code值
export default {
    name: "Index",
    components: {
        CommonHeader,
        CommonTop,
        ParkInfo,
        CropInfo,
        VideoInfo,
        EnvironmentalInfo,
        AgriculturalInfo,
        ReportInfo,
        PickingInfo,
    },
    data() {
        return {
            tabsActive: null, // 标签激活状态
            searchParams: {
                identificationCode: "", // 二维码的唯一码
            }, // 查询参数
            traceabilityInfo: {}, // 可追溯信息
            sheetFlag: false, // 动作面板显示状态
            emptyFlag: false, // 当一物一码过期、未到时间、使用次数用尽时显示空状态组件
            emptyType: "", // 错误类型  1 不在时间段内 2 次数用尽 3 校验通过
            identificationType: "", // 二维码类型  traceabilityCode 溯源码  oneCode 一物一码
            sheetInfo: {}, // 动作面板信息
        }
    },
    computed: {
        // 计算标签页组件
        calcTabsPage() {
            switch (this.tabsActive) {
                case "parkInfo":
                    return ParkInfo;
                case "cropInfo":
                    return CropInfo;
                case "videoInfo":
                    return VideoInfo;
                case "environmentInfo":
                    return EnvironmentalInfo;
                case "famringInfo":
                    return AgriculturalInfo;
                case "reportInfo":
                    return ReportInfo;
                case "pickInfo":
                    return PickingInfo;
            }
        },
        // 标签列表
        tabsList() {
            if (!this.traceabilityInfo.menu) return [];
            const menuList = this.traceabilityInfo.menu.split(',');
            const tabsList = [
                {
                    label: this.$t("menu.parkInfo"),
                    value: "parkInfo",
                },
                {
                    label: this.$t("menu.cropInfo"),
                    value: "cropInfo",
                },
                {
                    label: this.$t("menu.videoInfo"),
                    value: "videoInfo",
                },
                {
                    label: this.$t("menu.environmentInfo"),
                    value: "environmentInfo",
                },
                {
                    label: this.$t("menu.farmInfo"),
                    value: "famringInfo",
                },
                {
                    label: this.$t("menu.reportInfo"),
                    value: "reportInfo",
                },
                {
                    label: this.$t("menu.harvestInfo"),
                    value: "pickInfo",
                },
            ];
            return tabsList.filter(item => menuList.includes(item.value));
        },
        // 地图选项
        mapOptions() {
            return [{ name: this.$t("map.baiDu") }, { name: this.$t("map.gaoDe") }, { name: this.$t("map.tencent") }]
        },
        // 计算错误描述
        calcEmptyDesc() {
            switch (this.emptyType) {
                case 1:
                    return this.$t("empty.errorTime");
                case 2:
                    return this.$t("empty.errorNum");
                default:
                    return "";
            }
        },
    },
    async mounted() {
        await this.receiveFromUni();
        this.tabsActive = "parkInfo";
    },
    watch: {
        tabsActive: {
            handler(newVal) {
                if (!newVal) return;
                this.$nextTick(() => {
                    const findIndex = this.$refs.componentRef?.findIndex(item => item.$options?.parent?.name == this.tabsActive);
                    if (findIndex > -1) {
                        this.$nextTick(() => {
                            this.$refs.componentRef[findIndex]?.refresh();
                        })
                    }
                })
            },
        }
    },
    methods: {
        /**
         * 解析uniapp传递过来的数据
         */
        async receiveFromUni() {
            const urlParams = new URLSearchParams(window.location.search);
            const queryId = decodeURIComponent(urlParams.get("id"));
            // const queryType = decodeURIComponent(urlParams.get("type"));
            this.searchParams.identificationCode = Decrypt(queryId) || null;
            // this.identificationType = Decrypt(queryType) || null;
            if (this.searchParams.identificationCode) {
                await this.verifyQrCode();
            }
        },
        /**
         * 验证二维码是否可用
         */
        async verifyQrCode() {
            this.$toast.loading({
                message: this.$t("common.loading"),
                forbidClick: true,
            });
            try {
                const res = await this.$api.fetchFarmQrCodeToVerify(this.searchParams);
                this.$toast.clear()
                if (res.code != CODE_SUCCESS) {
                    this.$toast.fail(res.msg);
                    this.emptyFlag = true;
                } else {
                    this.emptyType = res.data || "";
                    if (this.emptyType == "3") {
                        // if (this.identificationType == "oneCode") {
                        //     await this.decrementCount();
                        // }
                        await this.getTraceabilityInfo();
                    } else {
                        this.emptyFlag = true;
                    }
                }
            } catch (error) {
                this.$toast.clear()
                console.error("错误", error);
                this.emptyFlag = true;
            }
        },
        /**
         * 减少二维码次数
         */
        // async decrementCount() {
        //     try {
        //         const res = await this.$api.fetchFarmQrCodeCountToSubtraction(this.searchParams);
        //         this.$toast.clear()
        //         if (res.code != CODE_SUCCESS) {
        //             this.$toast.fail(res.msg);
        //         }
        //     } catch (error) {
        //         this.$toast.clear()
        //         console.error("错误", error);
        //     }
        // },
        /**
        * 异步获取追溯信息
        */
        async getTraceabilityInfo() {
            this.$toast.loading({
                message: this.$t("common.loading"),
                forbidClick: true,
            });
            try {
                const res = await this.$api.fetchFarmQrCodeById(this.searchParams);
                this.$toast.clear()
                if (res.code != CODE_SUCCESS) {
                    this.$toast.fail(res.msg);
                } else {
                    this.traceabilityInfo = res.data || {};
                }
            } catch (error) {
                this.$toast.clear()
                console.error("错误", error);
            }
        },
        /**
        * 显示动作面板
        */
        showSheet(info) {
            this.sheetInfo = info;
            if (!this.sheetInfo.address || !this.sheetInfo.code) {
                this.$toast.fail(this.$t('tips.addressInvalid'));
                return;
            }
            this.sheetFlag = true;
        },
        sheetChange(action, index) {
            const cropInfo = this.sheetInfo || {};
            if (!cropInfo.address || !cropInfo.code) return;
            switch (index) {
                case 0:
                    this.navToMap(cropInfo.address, 1, cropInfo.code);
                    break;
                case 1:
                    this.navToMap(cropInfo.address, 2, cropInfo.code);
                    break;
                case 2:
                    this.navToMap(cropInfo.address, 3, cropInfo.code);
                    break;
            }
        },
        /**
        * 根据地址名称和地图类型，导航到对应的地图应用并标记位置
        * 功能说明：
        * 1. 使用高德地图API将地址转换为经纬度坐标
        * 2. 根据设备类型(iOS/Android)和地图类型(百度/高德/腾讯)生成对应的地图URL
        * 3. 通过window.location.href跳转到目标地图应用
        * @param {string} name - 要在地图上标记的位置名称
        * @param {number} type - 地图类型：1-百度地图，2-高德地图，3-腾讯地图
        */
        navToMap(name, type, code) {
            let self = this
            let url
            const u = navigator.userAgent
            //判断ios
            const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
            //判断Android
            const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1
            const long = code.split(",")[0];
            const lat = code.split(",")[1];
            if (isIOS) {
                switch (type) {
                    case 1: //百度地图
                        const point = mapPointTxTurnBaiDu(long, lat);
                        url = `http://api.map.baidu.com/marker?location=${point.bd_lat},${point.bd_lon}&title=${name}&content=${name}&output=html`
                        break
                    case 2: //高德地图
                        url = `http://uri.amap.com/marker?position=${long},${lat}&name=${name}&src=mypage&coordinate=gaode&callnative=0`
                        break
                    case 3: //腾讯地图
                        url = `http://apis.map.qq.com/uri/v1/marker?marker=coord:${lat},${long};addr:${name}`
                        break;
                    default:
                        break
                }
            } else {
                switch (type) {
                    case 1: //百度地图
                        const point = mapPointTxTurnBaiDu(long, lat);
                        url = `http://api.map.baidu.com/marker?location=${point.bd_lat},${point.bd_lon}&title=${name}&content=${name}&output=html`
                        break
                    case 2: //高德地图
                        url = `http://uri.amap.com/marker?position=${long},${lat}&name=${name}&src=mypage&coordinate=gaode&callnative=0`
                        break
                    case 3: //腾讯地图
                        url = `http://apis.map.qq.com/uri/v1/marker?marker=coord:${lat},${long};addr:${name}`
                        break;
                    default:
                        break
                }
            }
            window.location.href = url;
        }
    },
}
</script>
<style scoped>
.IndexBox {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
}

.indexEmpty {
    width: 100%;
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
}

.IndexContent {
    width: 100%;
    flex: 1;
}

/* 穿透样式 */
::v-deep .van-tabs__nav {
    background-color: transparent !important;
    padding: 0 0 9px !important;
}

::v-deep .van-tabs__wrap {
    padding: 0 20px !important;
}
</style>